import React, { useState } from 'react';
import Layout from '../../components/layout';
import { 
  Button,
  Divider,
  PageWrapper,
  Body,
  TitleQuestion,
  WrapperQuestion,
  Subtitle,
  WrapperButton,
  Question,
  LabelRadio,
  WrapperSuccess,
  RadionItems, 
  IMG} from '../../components/template';
import InputGroup from '../../components/template/input/inputGroup';
import RadioGroup from '../../components/template/input/radioGroup';
import DataType from '../../../application/data/dataType.json';
import DataBank from '../../../application/data/dataBank.json';
import { toast } from 'react-toastify';
import { uploadFunction } from '../../../application/helper/utilities';
import InputFile from '../../components/template/input/inputFile';

import LOADING from '../../../views/components/loading';
import { APIRequest } from '../../../application/helper/APIRequest';

function FormWiWallet() {
  const [stepPage, setStepPage] = useState(1);
  const [changeInput, setInput] = useState();
  const [type, setType] = useState();
  const [typeOfShop, setTypeOfShop] = useState();
  const [bankName, setBankName] = useState();
  const [imageBank, setImageBank] = useState();
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [imagePath, setImagePath] = useState();

  function handleInputOnChange(e) {
    const { name, value } = e.target;
    setInput({
      ...changeInput,[name]: value
    })
  }

  function handleSelectedType(type){
    setType(type)
  }

  function handleSelectedBankName(bank){
    setBankName(bank)
  }

  function handleSelectedTypeOfShop(typeOfShop){
    setTypeOfShop(typeOfShop)
  }

  function handleChangeImages(e){
    if (e && e.target.files[0]){
      setLoadingUpload(true);
      uploadFunction(e.target.files[0]).then(response => {
        const tempFile = [
          {
            url: response,
            blob: URL.createObjectURL(e.target.files[0])
          }
        ];
        if (tempFile) {
          setImageBank(tempFile);
          setImagePath(tempFile[0].url.substring(tempFile[0].url.lastIndexOf('/') + 1));
          setLoadingUpload(false);
        }
      });
    }
  }

  function handleNextStep(e, currentStep){
    e.preventDefault();
    if(stepPage === 2){
      if(!type){
        toast.error('กรุณาเลือก ประเภทสินค้าและบริการ');
      } else if (!bankName) {
        toast.error('กรุณาเลือก ธนาคาร');
      } else if (!imageBank) {
        toast.error('กรุณาเลือก รูปหน้าบัญชีธนาคาร');
      } else if(!typeOfShop) {
        toast.error('กรุณาเลือก ประเภทร้านค้า');
      } else {
        setLoadingUpload(true);
        const data = {
          brandNameTH: changeInput.brandNameTH,
          brandNameEN: changeInput.brandNameEN,
          shopNameTH: changeInput.shopNameTH,
          shopNameEN: changeInput.shopNameEN,
          type: type,
          dateOfContract: changeInput.dateOfContract,
          tel: changeInput.tel,
          name: changeInput.name,
          typeOfShop: typeOfShop,
          bankName: bankName,
          branch: changeInput.branch,
          accountNumber: changeInput.accountNumber,
          bankPage: imagePath,
          prefix: changeInput.prefix
        }
        APIRequest({
          method: 'POST',
          url: '/external/form-wallet/form',
          data: data,
        }).then(response => {
          setLoadingUpload(false);
          setStepPage(3)
        }).catch(error => {
          setLoadingUpload(true);
          return error;
        });
      }
    } else {
      setStepPage(currentStep + 1);
    }
  }

  function handleBackStep(currentStep){
    setStepPage(currentStep - 1);
  }

  return (
    <Layout>
      { loadingUpload && <LOADING /> }
      <PageWrapper form="true">
        <Body>
          <IMG src={require(`../../../assets/images/wi-wallet.jpg`).default} alt="Wi Wallet" />
          { !stepPage === 3 &&
            <h2>
              แบบฟอร์มลงทะเบียนเป็นผู้ค้าของ Wi Wallet
            </h2>
          }
          <Divider color="true" />
          { stepPage === 1 &&
            <form onSubmit={ (e) => handleNextStep(e, 1)}>
              <WrapperQuestion>
                <TitleQuestion>ข้อมูลแบรนด์</TitleQuestion>
                <Subtitle>ถ้าภายใต้แบรนด์มีแค่ร้านค้าเดียวสามารถใส่ชื่อแบรนด์เป็นชื่อเดียวกับร้านค้าได้</Subtitle>
              </WrapperQuestion>

              <WrapperQuestion>
                <Question>ชื่อแบรนด์ (ภาษาไทย)</Question>
                <InputGroup
                  autoComplete="off"
                  placeholder="คำตอบของคุณ"
                  defaultValue={changeInput?.brandNameTH}
                  name="brandNameTH"
                  onChange={ (e) => handleInputOnChange(e) }
                  required
                />
              </WrapperQuestion>

              <WrapperQuestion>
                <Question>ชื่อแบรนด์ (ภาษาอังกฤษ)</Question>
                <InputGroup
                  type="english"
                  autoComplete="off"
                  placeholder="คำตอบของคุณ"
                  defaultValue={changeInput?.brandNameEN}
                  name="brandNameEN"
                  onChange={ (e) => handleInputOnChange(e) }
                  required
                />
              </WrapperQuestion>
              <WrapperButton>
                <Button
                  primary
                  fixWidth
                  size="small"
                  type="submit"
                >ถัดไป</Button>
              </WrapperButton>
            </form>
          }
          { stepPage === 2 && DataType && DataBank &&
            <form onSubmit={ (e) => handleNextStep(e, 2)}>
              <WrapperQuestion>
                <TitleQuestion>ข้อมูลร้านค้า</TitleQuestion>
              </WrapperQuestion>
              
              <WrapperQuestion>
                <Question>ชื่อร้านค้า (ภาษาไทย)</Question>
                <InputGroup
                  autoComplete="off"
                  placeholder="คำตอบของคุณ"
                  name="shopNameTH"
                  defaultValue={changeInput?.shopNameTH}
                  onChange={ (e) => handleInputOnChange(e) }
                  required
                />
              </WrapperQuestion>              
              <WrapperQuestion>
                <Question>ชื่อร้านค้า (ภาษาอังกฤษ)</Question>
                <InputGroup
                  autoComplete="off"
                  type="english"
                  placeholder="คำตอบของคุณ"
                  name="shopNameEN"
                  defaultValue={changeInput?.shopNameEN}
                  onChange={ (e) => handleInputOnChange(e) }
                  required
                />
              </WrapperQuestion>
              <WrapperQuestion>
              <Question>ประเภทสินค้าและบริการ</Question>
                { DataType.map((item, index) => (
                  <RadionItems>
                    <RadioGroup
                      name="type"
                      key={index}
                      id={`type-${index}`}
                      defaultChecked= {type === `${item}`}
                      checked={type === `${item}`}
                      onChange={() => handleSelectedType(item)}
                    >
                      <LabelRadio htmlFor={`type-${index}`}>{item}</LabelRadio>
                    </RadioGroup>
                  </RadionItems>
                ))}
              </WrapperQuestion>
              <WrapperQuestion>
                <Question>เบอร์โทรร้านค้า</Question>
                <InputGroup
                  autoComplete="off"
                  type="tel"
                  id="tel"
                  name="tel"
                  maxLength="10"
                  pattern="\d*"
                  defaultValue={changeInput?.tel}
                  placeholder="คำตอบของคุณ"
                  onChange={ (e) => handleInputOnChange(e) }
                  required
                />
              </WrapperQuestion>
              <WrapperQuestion>
                <TitleQuestion noMargin>วันที่เริ่มต้นการใช้บริการรับชําระเงิน</TitleQuestion>
                <Subtitle noMargin>ร้านค้าตกลงใช้บริการรับชำระเงินตามข้อตกลงและเงื่อนไขเป็นระยะเวลา 1 ปี</Subtitle>
                <Question>วันที่</Question>
                <InputGroup
                  autoComplete="off"
                  type="date"
                  locale="th"
                  dateFormat="dd/MM/yyyy"
                  placeholder="dd/mm/yyyy"
                  name="dateOfContract"
                  defaultValue={changeInput?.dateOfContract}
                  onChange={ (e) => handleInputOnChange(e) }
                  required
                />
              </WrapperQuestion>

              <WrapperQuestion>
                <Question>ธนาคารที่ต้องการใช้รับชำระเงิน</Question>
                { DataBank.map((item, index) => (
                  <RadionItems>
                    <RadioGroup
                      name="bankName"
                      key={index}
                      id={`bankName-${index}`}
                      defaultChecked= {bankName === `${item}`}
                      checked={bankName === `${item}`}
                      onChange={() => handleSelectedBankName(item)}
                    >
                      <LabelRadio htmlFor={`bank-${index}`}>{item}</LabelRadio>
                    </RadioGroup>
                  </RadionItems>
                ))}
              </WrapperQuestion>
              <WrapperQuestion>
                <Question>ชื่อสาขา</Question>
                <InputGroup
                  autoComplete="off"
                  name="branch"
                  defaultValue={changeInput?.branch}
                  placeholder="คำตอบของคุณ"
                  onChange={ (e) => handleInputOnChange(e) }
                  required
                />
              </WrapperQuestion>
              <WrapperQuestion>
                <Question>เลขที่บัญชีธนาคาร</Question>
                <InputGroup
                  autoComplete="off"
                  name="accountNumber"
                  defaultValue={changeInput?.accountNumber}
                  type="tel"
                  pattern="\d*"
                  placeholder="คำตอบของคุณ"
                  onChange={ (e) => handleInputOnChange(e) }
                  required
                />
              </WrapperQuestion>

              <WrapperQuestion>
                <Question>อัพโหลดรูปหน้าบัญชีธนาคาร</Question>
                <InputFile
                  id="imageProduct"
                  name="imageProduct"
                  label="รูปหน้าบัญชีธนาคาร"
                  previewImage={imageBank && imageBank[0].blob}
                  onChange={(e) => handleChangeImages(e)}
                />
              </WrapperQuestion>
              <WrapperQuestion>
                <TitleQuestion noMargin>ชื่อ-นามสกุลผู้ติดต่อ</TitleQuestion>
                <Question>เจ้าของร้านค้า หรือผู้ที่มีหน้าที่รับผิดชอบในร้านค้า</Question>
                <InputGroup
                  autoComplete="off"
                  name="name"
                  defaultValue={changeInput?.name}
                  placeholder="คำตอบของคุณ"
                  onChange={ (e) => handleInputOnChange(e) }
                  required
                />
              </WrapperQuestion>
              <WrapperQuestion>
                <Question>ประเภทร้านค้า</Question>
                  <RadionItems>
                    <RadioGroup
                      id="typeOfShopOffline"
                      name="typeOfShop"
                      defaultChecked= {typeOfShop === 'offline'}
                      checked={typeOfShop === 'offline'}
                      onChange={() => handleSelectedTypeOfShop('offline')}
                    >
                      <LabelRadio>ออฟไลน์ (มีหน้าร้าน)</LabelRadio>
                    </RadioGroup>
                  </RadionItems>
                  <RadionItems>
                    <RadioGroup
                      id="typeOfShopOnline"
                      name="typeOfShop"
                      defaultChecked= {typeOfShop === 'online'}
                      checked={typeOfShop === 'online'}
                      onChange={() => handleSelectedTypeOfShop('online')}
                    >
                      <LabelRadio>ออนไลน์</LabelRadio>
                    </RadioGroup>
                  </RadionItems>
              </WrapperQuestion>
              <WrapperQuestion>
                <Question>Prefix</Question>
                <InputGroup
                  autoComplete="off"
                  name="prefix"
                  defaultValue={changeInput?.prefix}
                  placeholder="คำตอบของคุณ"
                  onChange={ (e) => handleInputOnChange(e) }
                  required
                />
              </WrapperQuestion>
              <WrapperButton>
                <Button
                  primary
                  fixWidth
                  size="small"
                  type="button"
                  onClick={ () => handleBackStep(2) }
                >ย้อนกลับ</Button>
                <Button
                  primary
                  fixWidth
                  size="small"
                  type="submit"
                >ยืนยันข้อมูล</Button>
              </WrapperButton>
            </form>
          }
          { stepPage === 3 && 
            <WrapperSuccess>
              <h3>ทางเราได้บันทึกข้อมูลเรียบร้อยแล้ว กรุณารอพนักงานติดต่อกลับ</h3>
            </WrapperSuccess>
          }
        </Body>
      </PageWrapper>
    </Layout>
  )
}

export default FormWiWallet;